const refrescarUser = objeto => {
    return {
        type: "refrescarUser",
        payload: objeto
    }
}

module.exports = {
    refrescarUser
}